import React, { useState } from "react";
import { useParams } from "react-router-dom";
import products from "../components/mariniProductsData";
import "../assets/css/MariniProductDetail.css"; // use same file, updated for Marini
import BreadcrumbSection from "./BreadcrumbSection";

const MariniProductDetail = () => {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));

  const [selectedImage, setSelectedImage] = useState(
    product ? product.images[0] : ""
  );
  const [activeTab, setActiveTab] = useState("application");
  const [showVideo, setShowVideo] = useState(false);

  if (!product) return <p>Product not found!</p>;

  return (
    <>
      <BreadcrumbSection
        title={product.name}
        breadcrumbItems={[
          { label: "Home", to: "/" },
          { label: "Marini Products", to: "/MariniProducts" },
        ]}
        backgroundImage={product.breadcrumbImage}
      />

      <section className="marini-product-details-section">
        <div className="marini-product-container">
          {/* Product Info */}
          <div className="marini-product-info">
            <div className="marini-product-image-section">
              <img
                src={selectedImage}
                alt={product.name}
                className="marini-main-image"
              />
              <div className="marini-thumbnail-row">
                {product.images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`marini-thumbnail ${
                      selectedImage === img ? "active-thumb" : ""
                    }`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="marini-product-description">
              <h2>{product.name}</h2>
              <p className="marini-sub-heading text-muted">
                {product.subHeading}
              </p>
              <h5>Product Overview</h5>
              <p>{product.overview}</p>
            </div>
          </div>

          {/* How To Use */}
          {/* {product.howToUse && (
            <div
              className="marini-how-to-use-section"
              style={{
                backgroundImage: `url(${product.howToUse.thumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="marini-text-content">
                <h3>
                  How To Use <span className="highlight">{product.name}?</span>
                </h3>
                <p>{product.howToUse.text}</p>
              </div>

              {product.howToUse.video && (
                <div
                  className="marini-video-thumbnail-wrapper"
                  onClick={() => setShowVideo(true)}
                >
                  <div className="marini-video-thumbnail">
                    <i className="bi bi-play-fill marini-play-icon"></i>
                  </div>
                </div>
              )}
            </div>
          )} */}

          {/* Video Popup */}
          {showVideo && product.howToUse.video && (
            <div className="marini-video-popup">
              <div className="marini-video-container">
                <video controls autoPlay>
                  <source src={product.howToUse.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button
                  className="marini-close-btn"
                  onClick={() => setShowVideo(false)}
                >
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Tabs */}
          <div className="marini-accordion-section">
            <div className="marini-accordion-tabs">
              {["benefits", "application"].map((tab) => (
                <button
                  key={tab}
                  className={`marini-accordion-tab ${
                    activeTab === tab ? "active" : ""
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                    ? "APPLICATION GUIDELINES"
                    : "INGREDIENTS"}
                </button>
              ))}
            </div>

            <div className="marini-accordion-content">
              {activeTab === "benefits" && (
                <div className="marini-tab-content fade-in">
                  <ul>
                    {product.benefits.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </div>
              )}
              {activeTab === "application" && (
                <div className="marini-tab-content fade-in">
                  <ol>
                    {product.application.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ol>
                </div>
              )}
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MariniProductDetail;
